<template>
  <div class="relative">
    <AvatarUser
      :user="activityItem.user"
      size="md"
      class="ring-8 ring-white dark:ring-gray-900"
    />

    <span
      class="absolute -bottom-0.5 -right-1 rounded-tl bg-white px-0.5 py-px dark:bg-gray-800"
    >
      <ChatAltIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
    </span>
  </div>
  <div class="min-w-0 flex-1">
    <div class="flex justify-between">
      <div>
        <div>
          <LinkBase
            v-if="activityItem.user.href"
            color="text-gray-900"
            size="text-sm"
            :href="activityItem.user.href"
            containerClass="inline"
            >{{ activityItem.user.name }}</LinkBase
          >
          <SpanText
            v-else
            color="text-gray-900"
            font="font-medium"
            size="text-sm"
            >{{ activityItem.user.name }}</SpanText
          >
        </div>
        <ParagraphText size="text-sm" color="text-gray-500" class="mt-0.5">
          Commented {{ activityItem.date }}
        </ParagraphText>
      </div>
      <DropdownBase v-if="activityItem.can?.update || activityItem.can?.delete">
        <template #trigger>
          <DropdownButtonMinimal />
        </template>
        <DropdownItemGroup>
          <DropdownItem
            v-if="activityItem.can.update"
            @click="editing = true"
            type="edit"
          />
          <DropdownItem
            v-if="activityItem.can.delete"
            @click="emit('delete', activityItem)"
            type="delete"
          />
        </DropdownItemGroup>
      </DropdownBase>
    </div>
    <div class="mt-2">
      <slot
        name="form"
        v-if="editing"
        :activityItem="props.activityItem"
        :cancelEdit="cancelEdit"
      />
      <ParagraphText v-else size="text-sm" color="text-gray-700">{{
        activityItem.body
      }}</ParagraphText>
    </div>
  </div>
</template>

<script setup>
import AvatarUser from '@/Common/Elements/Avatars/AvatarUser.vue'
import DropdownBase from '@/Common/Elements/Dropdowns/DropdownBase.vue'
import DropdownButtonMinimal from '@/Common/Elements/Dropdowns/DropdownButtonMinimal.vue'
import DropdownItem from '@/Common/Elements/Dropdowns/DropdownItem.vue'
import DropdownItemGroup from '@/Common/Elements/Dropdowns/DropdownItemGroup.vue'
import LinkBase from '@/Common/Text/LinkBase.vue'
import ParagraphText from '@/Common/Text/ParagraphText.vue'
import SpanText from '@/Common/Text/SpanText.vue'
import { ChatAltIcon } from '@heroicons/vue/solid'
import { ref } from 'vue'

const props = defineProps({
  activityItem: Object,
})

const emit = defineEmits(['delete'])

const editing = ref(false)

function cancelEdit() {
  editing.value = false
}
</script>
